import { mergeAttributes } from '@tiptap/core'
import Mention from '@tiptap/extension-mention'
import { PluginKey } from '@tiptap/pm/state'

// Named key required so isSuggestionActive() can detect an open @ menu on TipTap 2.27+.
export const MentionPluginKey = new PluginKey('mention')

export const CustomMention = Mention.extend({
  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes({ 'data-type': this.name }, this.options.HTMLAttributes, HTMLAttributes),
      `@${node.attrs.name}`
    ]
  },
  addAttributes() {
    return {
      id: {
        default: null,
        // The attribute value itself: returning an object here stored `data-mention="[object Object]"` on re-save
        parseHTML: element => element.getAttribute('data-mention'),
        renderHTML: attributes => {
          if (!attributes.id) {
            return {}
          }

          return {
            'data-mention': attributes.id
          }
        }
      },
      name: {
        default: null
      }
    }
  }
})
